import { create } from "zustand";
import { LeadsModalModeEnum } from '../api/models/Enums';
import { devtools } from "zustand/middleware";

export interface ModalState {
  isOpen: boolean;
  mode: any; 
}

export interface ModalStoreProps<T> {
  modalState: ModalState;
  openModal: (mode: ModalState["mode"]) => void;
  closeModal: () => void;
}

const useModalStore = create<ModalStoreProps<any>>()(devtools((set) => ({
  modalState: {
    isOpen: false,
    mode: LeadsModalModeEnum.NONE,
  },


  openModal: (mode) =>
    set({ modalState: { isOpen: true, mode } }),

  closeModal: () =>
    set({ modalState: { isOpen: false, mode: LeadsModalModeEnum.NONE} }),

}),
  { name: "LeadStore" }
));
useModalStore.subscribe((state) => {
});


export default useModalStore;
